import { useCollectionState } from 'modules/collection/state';
import { Gtm } from 'tracking';
import { memo, useCallback } from 'react';
import HeroFilterButtonComponent from '../../../../components/hero-filter-button';

interface FilterButtonProps {
  filterName: string;
}

/**
 * Button for the hero filter component.
 * With memo, only the affected filter button will be re-rendered, if a button is updated,
 * reducing the overall rendering time.
 */
const HeroFilterButton: React.FC<FilterButtonProps> = memo(({ filterName }) => {
  const { appliedFilter, toggleFilter } = useCollectionState();

  const handleToggleFilter = useCallback(() => {
    toggleFilter(filterName);

    const element = ['Hero Filter', filterName];

    if (appliedFilter.includes(filterName)) {
      Gtm.track.unselectElement({ element });
    } else {
      Gtm.track.selectElement({ element });
    }
  }, [appliedFilter, toggleFilter, filterName]);

  return (
    <HeroFilterButtonComponent
      filterName={filterName}
      handleToggleFilter={handleToggleFilter}
      isSelected={appliedFilter.includes(filterName)}
    />
  );
});

HeroFilterButton.displayName = 'HeroFilterButton';

export default HeroFilterButton;
